// Code generated by @keq-request/cli. DO NOT EDIT.
// Code generated by @keq-request/cli. DO NOT EDIT.
// Code generated by @keq-request/cli. DO NOT EDIT.

/* @anchor:file:start */
import { Module, ConfigurableModuleBuilder, Provider } from '@nestjs/common'
import { KeqRequest } from 'keq'
import { KeqModule, type KeqModuleOptions, KeqConsumer } from '@keq-request/nestjs'
import { OpenBaoHttpClient } from './open-bao-http.client'


export interface OpenBaoHttpModuleOptions extends KeqModuleOptions {
  /**
   * Whether to register the module globally.
   * @default false
   */
  isGlobal?: boolean
}

const KEQ_REQUEST_TOKEN = Symbol('OpenBaoHttpKeqRequest')
const KEQ_CONSUMER_TOKEN = Symbol('OpenBaoHttpKeqConsumer')

const { ConfigurableModuleClass, MODULE_OPTIONS_TOKEN } = new ConfigurableModuleBuilder<OpenBaoHttpModuleOptions>()
  .setExtras({ isGlobal: false }, (definition, extras) => ({
    ...definition,
    global: extras.isGlobal,
  }))
  .build()

const REQUEST_PROVIDER: Provider = {
  provide: KEQ_REQUEST_TOKEN,
  useFactory: (options: OpenBaoHttpModuleOptions, globalRequest?: KeqRequest) => {
    if (!options.isolate && !globalRequest) {
      console.warn('OpenBaoHttpModule: No global KeqRequest found, creating an isolated instance. Import KeqModule globally or set { isolate: true } to suppress this warning.')
    }

    const request = (!options.isolate && globalRequest)
      ? globalRequest.fork()
      : new KeqRequest()

    if (options.middlewares) {
      for (const middleware of options.middlewares) {
        request.use(middleware)
      }
    }

    return request
  },
  inject: [
    MODULE_OPTIONS_TOKEN,
    { token: KeqRequest, optional: true },
  ],
}

const CLIENT_PROVIDER: Provider = {
  provide: OpenBaoHttpClient,
  useFactory: (request: KeqRequest) => new OpenBaoHttpClient(request),
  inject: [KEQ_REQUEST_TOKEN],
}

const CONSUMER_PROVIDER: Provider = {
  provide: KEQ_CONSUMER_TOKEN,
  useFactory: (request: KeqRequest) => new KeqConsumer(request),
  inject: [KEQ_REQUEST_TOKEN],
}

/**
 * NestJS module that provides the {@link OpenBaoHttpClient} for dependency injection.
 *
 * This module requires a `KeqRequest` instance, which can be provided in two ways:
 *
 * **Option 1: Use the global `KeqModule` (recommended)**
 *
 * Import `KeqModule` globally, then register this module.
 * The module will fork from the global KeqRequest and inherit its middlewares.
 *
 * ```typescript
 * // app.module.ts
 * import { KeqModule } from '@keq-request/nestjs'
 *
 * @Module({
 *   imports: [
 *     KeqModule,
 *     OpenBaoHttpModule.register({
 *       isGlobal: true, // optional, default false
 *       middlewares: [], // module-level middlewares
 *     }),
 *   ],
 * })
 * export class AppModule {}
 * ```
 *
 * **Option 2: Provide an isolated `KeqRequest` instance**
 *
 * ```typescript
 * @Module({
 *   imports: [
 *     OpenBaoHttpModule.register({
 *       isolate: true, // no inherited middlewares
 *     }),
 *   ],
 * })
 * export class SomeFeatureModule {}
 * ```
 *
 * Then inject `OpenBaoHttpClient` in your services:
 *
 * ```typescript
 * @Injectable()
 * export class SomeService {
 *   constructor(private readonly client: OpenBaoHttpClient) {}
 * }
 * ```
 */
@Module({
  imports: [KeqModule],
  providers: [REQUEST_PROVIDER, CONSUMER_PROVIDER, CLIENT_PROVIDER],
  exports: [OpenBaoHttpClient, KEQ_CONSUMER_TOKEN],
})
export class OpenBaoHttpModule extends ConfigurableModuleClass {
  static readonly KEQ_REQUEST = KEQ_REQUEST_TOKEN
  static readonly KEQ_CONSUMER = KEQ_CONSUMER_TOKEN
}

/* @anchor:file:end */
